import './bootstrap';
import './plugins';
import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import './core/coreApp';
import './app/AppComponents';
import './app/DemoComponent';
import './app/Helpers/common/helpers';
import './common/Helper/translation';
import {resolveErrorMessage} from './common/Helper/Support/ToastMessageResolver';
import './common/commonComponent';
import './common/Helper/helpers'

window.Vue = Vue;

const pushGlobalErrorToast = (() => {
    let lastMessage = '';
    let lastTimestamp = 0;

    return message => {
        const normalized = `${message || ''}`.trim();

        if (!normalized) {
            return;
        }

        const now = Date.now();

        if (normalized === lastMessage && (now - lastTimestamp) < 3000) {
            return;
        }

        lastMessage = normalized;
        lastTimestamp = now;

        const toaster = window.__mozaliVueApp && window.__mozaliVueApp.$toastr;

        if (toaster && typeof toaster.e === 'function') {
            toaster.e('', normalized);
            return;
        }

        console.error(normalized);
    };
})();

const resolveUiRuntimeErrorMessage = (error, info = '') => {
    const details = `${error?.message || ''}`.trim();

    return resolveErrorMessage({
        message: details,
        debug: info && info !== details ? info : '',
    }, {
        key: 'ui_runtime_error',
        params: {details},
        defaultMessage: details ? `UI error: ${details}` : 'UI error',
    });
};

Vue.config.errorHandler = (error, vm, info) => {
    console.error(error);
    pushGlobalErrorToast(resolveUiRuntimeErrorMessage(error, info));
};

window.addEventListener('unhandledrejection', event => {
    pushGlobalErrorToast(resolveErrorMessage(event.reason, {
        key: 'unexpected_promise_rejection',
        defaultMessage: 'An unexpected operation failed.',
    }));
});


import VueChatScroll from 'vue-chat-scroll';
Vue.use(VueChatScroll);

/**
 * vuex
 */

Vue.use(Vuex);
import storeData from "./store/Index";
const store = new Vuex.Store(storeData);


/**
 * localization
 * $t('key') or this.$('key')
 * link: https://github.com/dkfbasel/vuex-i18n
 * */

Vue.use(vuexI18n.plugin, store);

// add translations directly to the application
let language = JSON.parse(window.localStorage.getItem('app-languages'));
let key = window.localStorage.getItem('app-language');
Vue.i18n.add(key, language);
// set the start locale to use
Vue.i18n.set(key);

/*------ localization end ------*/


const app = new Vue({
    store,
    el: '#app',
});

window.__mozaliVueApp = app;
